import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 8a3 3 0 0 1 3 -3h14a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3l0 -8","key":"svg-0"}],["path",{"d":"M6 10v4","key":"svg-1"}],["path",{"d":"M11 10a2 2 0 1 0 0 4","key":"svg-2"}],["path",{"d":"M14 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}]]

const IconFavicon = createReactComponent('outline', 'favicon', 'Favicon', __iconNode);

export default IconFavicon;